export default __webpack_public_path__ + "9503ec84c0d3495e2a2ebee7d29a4e87.png";